import { Button } from "components/Button";
import styled from "styled-components/macro";
import type { Theme } from "styled-system";
import { CssFlex } from "styles/helpers/layout";

import { calculateRem } from "styles/mixins/calculateRem";

export const StyledContainer = styled(CssFlex)`
  max-width: 70rem;
  flex-direction: column;
`;

export const StyledHeader = styled(CssFlex)`
  flex-direction: column;
  gap: 1rem;
`;
export const StyledContent = styled(CssFlex)`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 5rem;
  gap: 5rem;
`;

export const StyledImage = styled.img`
  margin: 2rem 0rem 1rem 0rem;
  width: 20rem;
  height: 17rem;
`;

export const StyledLearningItem = styled(CssFlex)`
  align-items: center;
  gap: ${calculateRem(12)};
  margin-bottom: ${calculateRem(8)};
  padding: ${calculateRem(8)} 0;
`;

export const StyledButton = styled(Button)`
  border-radius: 8px;
  margin: 1rem 0;
  font-weight: 400;
  font-size: 14px;
  padding: 0.5rem 1rem;
`;

export const StyledComingSoonChip = styled(CssFlex)<Theme>`
  padding: 0.5rem 0.8rem;
  background-color: ${(props) => props.theme.palette.red._950};
  border-radius: 20px;
  gap: 0.5rem;
  align-items: center;
  font-size: 14px;
  justify-content: center;
  height: 1.8rem;
`;
